import { SET_CREATE_PROJECT } from "../../constants";

export const createProject = (CreateProject: any = {}) => ({
  type: SET_CREATE_PROJECT,
  payload: CreateProject,
});
